import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "m-actionButton__iconContainer" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("button", {
    class: "m-actionButton",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clicked && _ctx.clicked(...args)), ["stop"]))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_IconComponent, {
        class: "m-actionButton__icon",
        "icon-id": _ctx.iconName
      }, null, 8, ["icon-id"])
    ]),
    (_ctx.isTranslationLabel)
      ? _withDirectives((_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass([{'smaller-width': _ctx.isGadget }, "m-actionButton__text"])
        }, null, 2)), [
          [_directive_translate, _ctx.label]
        ])
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass([{'smaller-width': _ctx.isGadget }, "m-actionButton__text"]),
          innerHTML: _ctx.label
        }, null, 10, _hoisted_2))
  ]))
}